import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SeatComponent } from './seat.component';
import { ReactiveFormsModule } from '@angular/forms';
import { ModalModule } from '../modal/modal.module';
import { InputSelectModule } from '../input-select/input-select.module';
import { SharedModule } from 'src/app/shared/shared.module';
import { InputSubmitModule } from '../input-submit/input-submit.module';

@NgModule({
  declarations: [SeatComponent],
  imports: [
    CommonModule,
    SharedModule,
    ReactiveFormsModule,
    ModalModule,
    InputSelectModule,
    InputSubmitModule
  ],
  exports: [SeatComponent]
})
export class SeatModule {}
